import Actions from './actions';

const initialState = {
  notifications: [],
};

const VARIANTS = {
  [Actions.ERROR]: 'error',
  [Actions.SUCCESS]: 'success',
  [Actions.WARNING]: 'warning',
  [Actions.INFO]: 'info',
  [Actions.GENERAL]: 'default',
};

const notifications = (state = initialState, action) => {
  switch (action.type) {
    case Actions.ERROR:
    case Actions.INFO:
    case Actions.WARNING:
    case Actions.GENERAL:
    case Actions.SUCCESS: {
      return {
        notifications: [
          {
            message: action.message,
            variant: VARIANTS[action.type],
            options: action.options,
          },
        ],
      };
    }
    default:
      return state;
  }
};

export default notifications;
